import { Quote } from "lucide-react";

export default function ReviewsSection({ reviews }) {
  if (!reviews.length) return null;

  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-32 bg-zinc-950/50">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <p className="text-rose-700 uppercase tracking-[0.3em] text-sm font-bold">
          Testimonials
        </p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-white mt-3 tracking-tight">
          What Readers Are Saying
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {reviews.map((review, i) => (
            <article
              key={review.id}
              data-testid={`review-card-${review.id}`}
              className="review-card bg-zinc-900/50 border border-white/5 p-8 backdrop-blur-sm"
            >
              <Quote className="h-8 w-8 text-rose-700/40 mb-4" />
              <blockquote>
                <p className="text-zinc-300 leading-relaxed italic text-sm">
                  "{review.quote}"
                </p>
              </blockquote>
              <footer className="mt-6 pt-4 border-t border-white/10">
                <p className="text-white font-bold text-sm">{review.reviewer_name}</p>
                <p className="text-rose-700 text-xs mt-1">for '{review.book_title}'</p>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
